// extracted by mini-css-extract-plugin
export default {"container":"ConfirmModal_container__uBymp","buttonsContainer":"ConfirmModal_buttonsContainer__Dvh+G","button":"ConfirmModal_button__CM4hh"};